

import { degrees } from "framer-motion";
import api from "../api";
import {
  user,
  category,
  subcategory,
  product,
  service,
  Alluser,
  gst,
  vendor,
  login,
  holiday,
  employeeCreate,
  profile,
  purchase,
  sell,
  userList_sell,
  store_type,
  WorkAssign,
  shop_type,
  Expenditures,
  review,
  WorkAssignEmployee,
  Order,
  PayRoll,
  checkouts,
  serviceRequest,
  courier,
  userExtra,
  menu,
  empLeave,
  customizeRequest,
  report,
  support,
  availabilityDate,
  test
} from "../api_endpoints";
const { reviewQuestionAdd, reviewQuestionGet } = review;
const {
  user_add,
  user_List,
  user_category,
  user_category_assign,
  user_otp,
  userVerify_otp,
} = user;
const { loginApi,profileApi, LOGOUT_API } = login;
const { storeType,storeAll } = store_type;
const { shopType } = shop_type;
const { PayRollApi,doctorPayRollPaymentApi,doctorPayRollPaymentHistoryApi } = PayRoll;
const { ExpendituresApi } = Expenditures;
const { WorkAssignApi } = WorkAssign;
const { RMWorkAssignApi, DoctorsChemberApi } = WorkAssignEmployee;
const { userListSellApi } = userList_sell;
const { purchaseBillApi, purchaseBillListApi,allProductAvailableToSell } = purchase;
const { sellBillApi, sellBillListApi } = sell;
const { get_PeofileApi, update_PeofileApi } = profile;
const {addCourier,getCouriers,editCourier,craeteDelivery}=courier
const {getAgents}=userExtra
const {
  employeeRole,
  get_employeeRole,
  employeeAssign,
  getRegionalManager,
  getMarketingExecutive,
  teamCreate,
  employeePayRole,
  employeePayroleList,
} = employeeCreate;
const { get_holiday, holiday_Add } = holiday;
const {
  category_add,
  category_List,
  updateCategory_toggle,
  updateCategory_status,
  updateCategory_name
} = category;
const {
  subcategory_add,
  subcategory_List,
  updateSubCategory_status,
  updateSubCategory_toggle,
  updateSubCategory_name
} = subcategory;
const {
  product_add,
  product_List,
  updateProduct_toggle,
  updateProduct_status,
  updateProduct,
} = product;
const { service_add, service_list,updateServiceToggle_api,updateServiceOnline_status,updateServiceData_Api } = service;
const { admin, agent, doctor, employee, patient, userRoleDetais ,shopOwner} = Alluser;
const { vendor_list } = vendor;
const { get_gst, gst_Add } = gst;
const { OrderApi, OrderListApi, OrderApprovedApi } = Order;
const {getCheckouts,confirmCheckout,getServiceBoy,getMedicalTechnicianApi,addServiceBoy,dispatchCheckout,getStoreCheckouts}=checkouts;
const {getServiceRequest,assignServicePersonApi}=serviceRequest

export const doctorPayRollPaymentAPI = async (data, token) => {
  let result = [];
  try {
    const response = await api.post(doctorPayRollPaymentApi, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};
export const doctorPayRollPaymentHistoryAPI = async (token) => {
  let result = [];
  try {
    const response = await api.get(doctorPayRollPaymentHistoryApi, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const PayRollAPI = async (token) => {
  let result = [];
  try {
    const response = await api.get(PayRollApi, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};


export const OrdersApi = async (token) => {
  let result = [];
  try {
    const response = await api.get(OrderApi, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const OrdersApprovedAPI = async (token, orderId) => {
  try {
    const response = await api.put(
      `/adminweb/store/${orderId}/approve`,{},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Approval Error:", error);
    throw error;
  }
};

export const OrdersListApi = async (token) => {
  let result = [];
  try {
    const response = await api.get(OrderListApi, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const RMworkAssignApi = async (data, token) => {
  let result = [];
  try {
    const response = await api.post(RMWorkAssignApi, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const getChamberByDoctorIdApi = async (doctorId, token) => {
  let result = [];
  try {
    const response = await api.get(`${DoctorsChemberApi}/${doctorId}/chamber`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const userAdd = async (data, token) => {
  let result = [];
  try {
    console.log("data to be sent:", data);
    
    const response = await api.post(user_add, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const reviewQuestionAddApi = async (data, token) => {
  let result = [];
  try {
    const response = await api.post(reviewQuestionAdd, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const getreviewQuestionApi = async (token) => {
  let result = [];
  try {
    const response = await api.get(reviewQuestionGet, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

// export const userOtpVerify = async (data,token) => {
//   let result = [];
//   try {
//     const response = await api.post(userVerify_otp, data, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });

//     console.log("Response:", response);
//     result = response;
//   } catch (error) {
//     console.error("Network Error:", error.message);
//     return error.response;
//   }
//   return result;
// };
export const userOtp = async (data, token) => {
  let result = [];
  try {
    const response = await api.post(
      user_otp,
      { phone: data },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};
export const getRegionalManagerApi = async (token) => {
  let result = [];
  try {
    const response = await api.get(getRegionalManager, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const getExpendituresApi = async (token) => {
  let result = [];
  try {
    const response = await api.get(ExpendituresApi, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const getMarketingExecutiveApi = async (token) => {
  let result = [];
  try {
    const response = await api.get(getMarketingExecutive, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const userList = async (token) => {
  let result = [];
  try {
    const response = await api.get(user_List, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const teamCreateApi = async (data, token) => {
  let result = [];
  try {
    const response = await api.post(teamCreate, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const workAssignApi = async (data, token) => {
  let result = [];
  try {
    const response = await api.post(WorkAssignApi, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const employeePayRoleApi = async (data, id, token) => {
  let result = [];
  try {
    const response = await api.post(`${employeePayRole}/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const storeAllList = async (token) => {
  let result = [];
  console.log("token for store type: ", token);
  try {
    const response = await api.get(storeAll, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const storeTypeList = async (token) => {
  let result = [];
  console.log("token for store type: ", token);
  try {
    const response = await api.get(storeType, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const shopTypeList = async (token) => {
  let result = [];
  console.log("token for store type: ", token);
  try {
    const response = await api.get(shopType, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const userCategory = async (token) => {
  let result = [];
  try {
    const response = await api.get(user_category, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const categoryAdd = async (data, token) => {
  let result = [];
  try {
    const response = await api.post(category_add, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const categoryList = async (token) => {
  let result = [];
  try {
    const response = await api.get(category_List, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const subCategoryAdd = async (data, token) => {
  let result = [];
  try {
    const response = await api.post(subcategory_add, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const subCategoryList = async (token) => {
  let result = [];
  try {
    const response = await api.get(subcategory_List, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};
export const productTypesList = async (token) => {
  let result = [];
  try {
    const response = await api.get(product.bookingTypes, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const productAdd = async (data, token) => {
  let result = [];
  try {
    const response = await api.post(product_add, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const updateProductApi = async (data, token) => {
  let result = [];
  try {
    const response = await api.put(updateProduct, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const serviceAdd = async (data, token) => {
  let result = [];
  try {
      console.log("Submitting form data:", data);
      console.log("Token:", token);
      
    const response = await api.post(service_add, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
 
 
    console.log("Response:", response);
    result = response;
     return result;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
 
};

export const subServiceList = async (token) => {
  let result = [];
  try {
    const response = await api.get(service_list, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const categoryAssign = async (data, userType, token) => {
  console.log("token : ", token);
  console.log("data : ", data);
  let result = [];
  try {
    const response = await api.post(
      `${user_category_assign}?categoryId=${userType}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json"
        },
      }
    );

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const adminList = async (token) => {
  let result = [];
  try {
    const response = await api.get(admin, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};
export const agentList = async (token) => {
  let result = [];
  try {
    const response = await api.get(agent, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};
export const doctorList = async (token) => {
  let result = [];
  try {
    const response = await api.get(doctor, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const hospitalList = async (token) => {
  let result = [];
  try {
    const response = await api.get(Alluser.hospital, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const diagnosticList = async (token) => {
  let result = [];
  try {
    const response = await api.get(Alluser.diagnostic, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};
export const employeeList = async (token) => {
  let result = [];
  try {
    const response = await api.get(employee, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const patientList = async (token) => {
  let result = [];
  try {
    const response = await api.get(patient, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const getGst = async (token) => {
  let result = [];
  try {
    const response = await api.get(get_gst, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const updateCategoryToggle = async (data, token) => {
  let result = [];
  try {
    const response = await api.put(`${updateCategory_toggle}/${data}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const updateCategoryStatus = async (data, token) => {
  let result = [];
  try {
    const response = await api.put(
      `${updateCategory_status}/${data}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const updateSubCategoryToggle = async (data, token) => {
  let result = [];
  try {
    const response = await api.put(
      `${updateSubCategory_toggle}/${data}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const updateServiceToggle = async (data, token) => {
  let result = [];
  try {
    const response = await api.put(
      `${updateServiceToggle_api}/${data}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const updateSubCategoryStatus = async (data, token) => {
  let result = [];
  try {
    const response = await api.put(
      `${updateSubCategory_status}/${data}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const updateServiceOnlineStatus = async (data, token) => {
  let result = [];
  try {
    const response = await api.put(
      `${updateServiceOnline_status}/${data}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const productList = async (token) => {
  let result = [];
  try {
    const response = await api.get(product_List, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const updateProductToggle = async (data, token) => {
  let result = [];
  try {
    const response = await api.put(`${updateProduct_toggle}/${data}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const updateProductStatus = async (data, token) => {
  let result = [];
  try {
    const response = await api.put(
      `${updateProduct_status}/${data}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

// export const vendorAdd = async (formData,id) => {
//   console.log("categoryId : ",id)
//   let result = [];
//   try {
//     const response = await api.post(`${vendor_add }?categoryId=${id}`,formData, {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },

//     });

//     console.log("Response:", response);
//     result = response;
//   } catch (error) {
//     console.error("Network Error:", error.message);
//     return error.response;
//   }
//   return result;
// };

export const vendorList = async (token) => {
  let result = [];
  try {
    const response = await api.get(vendor_list, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const loginAdmin = async (data) => {
  let result = [];
  try {
    const response = await api.post(loginApi, data);


    result = response;
  } catch (error) {
    console.log(error);
    
    console.error("Network Error:", error.message);
    return error;
  }
  return result;
};

export const gstAddApi = async (data, token) => {
  let result = [];
  try {
    const response = await api.post(gst_Add, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const gstList = async (token) => {
  let result = [];
  try {
    const response = await api.get(
      get_gst,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const holidayAddApi = async (data, token) => {
  let result = [];
  try {
    const response = await api.post(holiday_Add, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const holidayList = async (token) => {
  let result = [];
  try {
    const response = await api.get(get_holiday, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const employeeRoleApi = async (data, token) => {
  let result = [];
  console.log("data:", data);
  console.log("token:", token);

  try {
    const response = await api.post(employeeRole, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};
export const employeeRoleAssign = async (data, token) => {
  let result = [];
  console.log("data:", data);
  console.log("token:", token);
  try {
    const response = await api.post(employeeAssign, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const get_EmployeeRole = async (token) => {
  let result = [];
  try {
    const response = await api.get(get_employeeRole, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};
export const getEmployeeRolePermission = async (token) => {
  let result = [];
  try {
    const response = await api.get(employeeCreate.employeePermission, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const getPeofileApi = async (token) => {
  console.log("token in api ; ", token);
  let result = [];
  try {
    const response = await api.get(get_PeofileApi, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const purchaseApi = async (data, token) => {
  let result = [];
  console.log(data);
  
  try {
    const response = await api.post(purchaseBillApi, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const purchaseList = async (token) => {
  let result = [];
  try {
    const response = await api.get(purchaseBillListApi, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const sellApi = async (data, token) => {
  let result = [];
  console.log("token : ", token);
  console.log("data : ", data);
  try {
    const response = await api.post(sellBillApi, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const sellList = async (token) => {
  let result = [];
  try {
    const response = await api.get(sellBillListApi, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const userListSell = async (token) => {
  let result = [];
  try {
    const response = await api.get(userListSellApi, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
    console.log(error);
    
  }
  return result;
};

export const userRole = async (id, token) => {
  let result = [];
  try {
    const response = await api.get(`${userRoleDetais}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response.data;
  } catch (error) {
    console.error("Network Error:", error.message);
  }
  return result;
};

export const updatePrifileApi = async (token, data) => {
  let result = [];
  console.log("updatd data",data);
  
  try {
    const response = await api.put(update_PeofileApi, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const get_logout = async (token) => {
  let result = [];
  console.log(token);
  
  try {
    const response = await api.post(
      LOGOUT_API,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("Logout : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};



export const allProductToSell=async(token)=>{
  try {
    const response =await api.get(allProductAvailableToSell,{
       headers: {
          Authorization: `Bearer ${token}`,
        },
    })
    console.log(response);
    return response
    
  } catch (error) {
    throw error
  }
}

export const getCheckoutList=async(token)=>{
  try {
    const response = await api.get(getCheckouts, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Checkout Response:", response);
    return response.data;
    
  } catch (error) {
    throw error
  }
}

export const getStoreCheckoutList=async(token)=>{
  try {
    const response = await api.get(getStoreCheckouts, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Checkout Response:", response);
    return response.data;
    
  } catch (error) {
    throw error
  }
}

export const confirmCheckoutHandle=async(id,token)=>{
  try {
    const response = await api.put(`${confirmCheckout}/${id}/confirm`,{}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Conform Checkout Response:", response);
    return response;
    
  } catch (error) {
    throw error;
  }
}

export const confirmCheckoutStore=async(orderId,token,dispatchData)=>{
  
  try {
    const response = await api.put(`adminweb/store/${orderId}/approve`,{
      orderId,
      productSerials:dispatchData
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Conform Checkout Response:", response);
    return response;
    
  } catch (error) {
    throw error;
  }
}



export const getServiceBoyList=async(token)=>{
  try {
    const response = await api.get(getServiceBoy, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Service Response:", response);
    return response.data;
    
  } catch (error) {
    throw error
  }
}
export const getMedicalTechnicianList=async(token)=>{
  try {
    const response = await api.get(getMedicalTechnicianApi, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Service Response:", response);
    return response.data;
    
  } catch (error) {
    throw error
  }
}

export const assignServiceBoy=async(token,data)=>{
  try {

     console.log(data);
    const response=await api.post(addServiceBoy,{commonuserId:data.commonuserId,servicePersonId:data.employeeId,checkoutId:data.checkoutId},{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    console.log(response);
    return response;
    
    
  } catch (error) {
    throw error
  }
}

export const dispatchCheckoutHandle=async(token,data)=>{
  try {
    const response=await api.post(dispatchCheckout,{
      checkoutId:data.checkoutId,
      customerId:data.customerId,
      dispatchNumber:data.dispatchNumber,
      dispatchDate:Date.now(),
      serialNumbers:data.serialNumbers,
    },{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    console.log(response);
    return response
    
    
  } catch (error) {
    throw error;
  }
}

export const getServiceRequestHandler=async(token)=>{
  try {
    const response=await api.get(getServiceRequest,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response
    
  } catch (error) {
    throw error
  }
}

export const assignServicePerson=async(token,data)=>{

  try {
    const response=await api.post(assignServicePersonApi,{
      servicePersonCommonuserId:data.servicePersonCommonuserId,
      servicePersonId:data.servicePersonId,
      checkoutId:data.checkoutId,
      serviceRequestId:data.serviceRequestId,
      storeOwnerId:data.storeOwnerId

    },{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response;
    
  } catch (error) {
    throw error
  }
}

export const getEmployeePayroleList=async(token)=>{
  try {
    const response=await api.get(employeePayroleList,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response;
  } catch (error) {
    throw error
  }
}

export const getProfileData=async(token)=>{
  try {
    const response=await api.get(profileApi,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    console.log("profile",response.data);
    return response.data
    
  } catch (error) {
    console.log(error);
    throw error
    
  }
}

export const updatecategoryName=async(data,token)=>{
  try {
    console.log(token);
    
    const response=await api.put(`${updateCategory_name}/${data.id}`,{productCategoryName:data.categoryname},{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    console.log("result",response.data);
    return response.data
    
  } catch (error) {
    console.log(error);
    throw error
    
  }
}

export const updatesubcategoryName=async(data,token)=>{
  try {
    console.log(token,data);
    
    const response=await api.put(`${updateSubCategory_name}/${data.id}`,{productSubCategoryName:data.subcategoryname},{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    console.log("result",response.data);
    return response.data
    
  } catch (error) {
    console.log(error);
    throw error
    
  }
}

export const updateServicedata=async(id,data,token)=>{
  try {
    console.log(data);
    const response= await api.put(`${updateServiceData_Api}/${id}`,data,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    console.log("response",response);
    

    return response
    
  } catch (error) {
    console.log(error);
    throw error
  }
}



export const addCourierApi = async (data,token) => {
  let result = [];
  try {
    const response = await api.post(addCourier,data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const getCouriersListApi = async (token) => {
  let result = [];
  try {
    const response = await api.get(getCouriers, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const editCouriersApi = async (id,data,token) => {
  let result = [];
  try {
    const response = await api.put(`${editCourier}/${id}`,data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const createDeliveryForSell = async (data,token) => {
  let result = [];
  console.log(data);
  
  try {
    const response = await api.post(craeteDelivery,data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const getAgentList = async (token) => {
  let result = [];
  try {
    const response = await api.get(getAgents, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const getShopOwnerList = async (token) => {
  let result = [];
  try {
    const response = await api.get(shopOwner, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};


export const getMenuSubmenu=async(token)=>{
   let result = [];
  try {
    const response = await api.get(menu.get_menu, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
}

export const addNewRole=async(data)=>{
  let body={
    categoryId:1,
    employeeRoleName:data.categoryname,
    menus:data.menus,
    submenus:data.submenus,

  }
  console.log("body",body);
  return
  
  try {
    const res=await api.post(menu.insert_New,body,{
      headers: {
        Authorization: `Bearer ${data.token}`,
      },
    })
    return res
  } catch (error) {
   throw error 
  }
}

export const addDocChamber=async(data)=>{
 
  let body=data.body
  console.log(body);
  
  
  try {
    const res=await api.post(Alluser.doctorAddChamber,body,{
      headers: {
        Authorization: `Bearer ${data.token}`,
      },
    },)
    return res
  } catch (error) {
   throw error 
  }
}
export const editDocChamber=async(data)=>{
 
  let body=data.body
  console.log(body);
  
  
  try {
    const res=await api.put(Alluser.doctorlinkedChamberEdit,body,{
      headers: {
        Authorization: `Bearer ${data.token}`,
      },
    },)
    return res
  } catch (error) {
   throw error 
  }
}
export const removeDocChamber=async(id,token)=>{


  try {
    const res=await api.delete(Alluser.doctorlinkedChamberRemove+id,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },)
    return res
  } catch (error) {
   throw error 
  }
}

export const seniorMarketingExecutiveList=async(token)=>{
  try {
    const res=await api.get(Alluser.seniorMarketingExecutive,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return res
  } catch (error) {
    throw error;
  }
}

export const seniorMarketingExecutivePincodeAdd=async(payload,token)=>{
 
console.log(payload,token);

  try {
    const res=await api.post(Alluser.merketingExecutivePincodeAdd,payload,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },)
     console.log(res);
    return res
   
    
  } catch (error) {
    console.log(error);
    
   throw error 
  }
}

export const seniorMarketingExecutivePincodeList=async(id,token)=>{
 

  try {
    const res=await api.get(Alluser.merketingExecutivePincodeLinked+Number(id),{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },)
    return res
  } catch (error) {
   throw error 
  }
}

export const getUploadedReportsByME=async(token)=>{
 

  try {
    const res=await api.get(Alluser.allDoctorVisitReoprtByME,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },)
    return res
  } catch (error) {
   throw error 
  }
}

export const fetchStoreExpenditure=async(token)=>{
  try {
    const res=await api.get(store_type.getStoreExpenditure,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return res
  } catch (error) {
    throw error;
  }
}

export const employeepayrollBulk=async(data)=>{
  let body=data.data
  console.log(data.data);
  

  try {
    const res=await api.post(PayRoll.employeePayrollAll,body,{
      headers: {
        Authorization: `Bearer ${data.token}`,
      },
    },)
    return res
  } catch (error) {
   throw error 
  }
}

export const updateDoctorData=async(data)=>{
  console.log(data);
  
  try {
    const formdata=new FormData();
    formdata.append('doctorId',data.doctorId)
    formdata.append("profession",data.profession);
    formdata.append("specialization",data.specialization);
    formdata.append("degree",data.degree)
    formdata.append("relationWithCo",data.relationWithCo)
    formdata.append("numberOfCo",data.numberOfCo)
    formdata.append("aadhaarImage",data.aadhaarImage)

    const response=await api.put(Alluser.editDoctor,formdata,{
      headers: {
        Authorization: `Bearer ${data.token}`,}})
      return response
    
  } catch (error) {
    throw error
  }
}


export const gstAllCustomizedBooking = async (token) => {
  let result = [];
  try {
    const response = await api.get(
      serviceRequest.getCustomizedBooking,
    
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response gstAllCustomizedBooking:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const assignCustomizedBooking = async (token,servicePersonId,customizedRequestId) => {
  let result = [];
  try {
    const response = await api.post(
      serviceRequest.assignCustomizeBookingApi,
    {servicePersonId,customizedRequestId},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response gstAllCustomizedBooking:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};



export const gstAllLeaveTypes = async (token) => {
  let result = [];
  try {
    const response = await api.get(
      empLeave.getLeaveTypes,
    
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response gstAll leave types:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const getAvailableLeaves = async (token) => {
  let result = [];
  try {
    const response = await api.get(
      empLeave.getAvailableLeaves,
    
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response gstAll leave types:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const employeeLeaveApply = async (data,token) => {
  let result = [];
  try {
    const response = await api.post(
      empLeave.employeeLeaveApply,
    data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response gstAll leave types:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};



export const getAlLeaveApplyByEmployee = async (token) => {
  let result = [];
  try {
    const response = await api.get(
      empLeave.getAllLeaveByEmployee,
    
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response gstAll leave types:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const approveEmployeeLeave = async (data,token) => {
  let result = [];
  try {
    const response = await api.post(
      empLeave.approveLeave,
    data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response gstAll leave types:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};


export const getMonthWiseLeave = async (token) => {
  let result = [];
  try {
    const response = await api.get(
     `${ empLeave.monthWiseLeave}?date=2025-12-01`,
    
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response gstAll leave month wise:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};


export const getStoreWalletbalance = async (token) => {
  let result = [];
  try {
    const response = await api.get(
      empLeave.getStoreWallets,
    
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response gstAll leave month wise:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};


export const addStoreBalance= async (data,token) => {
  let result = [];
  try {
    const response = await api.post(
      empLeave.addStoreBalanceWallet,
    data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response gstAll leave month wise:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};



export const getCustomizedRequestTestData = async (token) => {
  let result = [];
  try {
    const response = await api.get(
      customizeRequest.getRequestData,
    
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response gstAll leave month wise:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};




export const getTeamListMethod = async (token) => {
  let result = [];
  try {
    const response = await api.get(
      employeeCreate.getTeamList,
    
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response team list:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};


export const getUpdateStore = async (data,token) => {
  let result = [];
  try {
    const response = await api.put(
      employeeCreate.storeUpdate,
    data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response team list:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};


export const getRMWorkList= async (token) => {
  let result = [];
  try {
    const response = await api.get(
     WorkAssign.getRMAssignedWork,
    
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response team list:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};


export const getListServiceReminder= async (token) => {
  let result = [];
  try {
    const response = await api.get(
     serviceRequest.getServiceReminderList,
    
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response team list:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const assignCallingPersonServiceReminder= async (data) => {
  let result = [];
  try {
    const response = await api.post(
     serviceRequest.assignCallingPerson,
     {
      serviceScheduleId:data.serviceScheduleId,
      callingPersonEmployeeId:data.callingPersonEmployeeId
     }
    ,
      {
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }
    );

    console.log("Response team list:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};


export const getListServiceReminderCallingPerson= async (token) => {
  let result = [];
  try {
    const response = await api.get(
     serviceRequest.getServiceReminderCallingPerson,
    
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response team list:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const addWalletBalanceToEmployee= async (token,employeeId,amount) => {
  let result = [];
  console.log( "employeeId:", employeeId,
       " amount: ",amount);
  
  try {
    const response = await api.post(
     employeeCreate.employeeWalletAdd,
    {
        employeeId: employeeId,
        amount: amount
    },
      {
        headers: {
          Authorization: `Bearer ${token}`,
         
        },
      }
    );

    console.log("Response team list:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const updateServiceReminderFollowup= async (data) => {
  let result = [];
  try {
    const response = await api.post(
     serviceRequest.updateServiceReminderFollowup,
     {
      serviceScheduleAssignmentId:data.serviceScheduleAssignmentId,
      nextFollowUpAt:data.nextFollowUpAt,
      note:data.note
     }
    ,
      {
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }
    );

    console.log("Response team list:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const getListServiceReminderCallingPersonInProgress= async (token) => {
  let result = [];
  try {
    const response = await api.get(
     serviceRequest.getServiceReminderCallingPersonInProgress,
    
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Response team list:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const markCompleteServiceReminder= async (data) => {
  let result = [];
  try {
    const response = await api.post(
     serviceRequest.markCompleteServiceReminder,
     {
      serviceScheduleAssignmentId:data.serviceScheduleAssignmentId,
   
      note:data.note
     }
    ,
      {
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }
    );

    console.log("Response team list:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const assignServiceBoyReminder= async (data) => {
  let result = [];
  try {
    const response = await api.post(
     `${serviceRequest.assignServiceBoyReminder}${data.id}/assign`,
     {
       pickupDateTime:data.pickupDateTime,
       pickupLocation:data.pickupLocation,
       alternateNumber:data.alternateNumber,
       servicePersonId:data.servicePersonId,
       productId:data.productId,
       serialNumber:data.serialNumber
     }
    ,
      {
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }
    );

    console.log("Response team list:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};


export const getIncomeReport = async (token) => {
  let result = [];
  try {
    const response = await api.get(report.getIncomeReport, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
}

export const forgetPassword= async (data) => {
  let result = [];
  try {
    const response = await api.post(
     login.forgetPassword,
     {
       email:data.email
     }
    
      
    );

    console.log("Response team list:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const resetPassword= async (data) => {
  let result = [];
  try {
    const response = await api.post(
     login.resetPassword,
     {
       token:data.token,
       newPassword:data.newPassword
     }
    
      
    );

    console.log("Response team list:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
};

export const getTotalExpendetureReport = async (token) => {
  let result = [];
  try {
    const response = await api.get(report.expenditureTotal, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
}

export const getStoreWalletPayExpenditure = async (token) => {
  let result = [];
  try {
    const response = await api.get(report.storeWalletPayExpenditure, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Response:", response);
    result = response;
  } catch (error) {
    console.error("Network Error:", error.message);
    return error.response;
  }
  return result;
}



export const userSupportMessages=async(token)=>{
  try {
  
    const response = await api.get(support.supportRequest, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}

export const userSupportChats=async(data)=>{
  try {
  
    const response = await api.get(`${support.getSupportChat}${data.id}`, {
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${data.token}`},
        withCredentials: true,
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}

export const replyUserSupportChats=async(data)=>{
  try {
    let body={
      supportId:data.id,
      message:data.message
    }
  
    const response = await api.post(support.replyToSupport,body, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${data.token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}

export const employeeLocationReportId=async(data)=>{
  try {
  
    const response = await api.get(`${report.employeeLocationReportById}${data.id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${data.token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}

export const doctorCommissionId=async(data)=>{
  try {
  
    const response = await api.get(`${PayRoll.doctorCommissionById}${data.id}/commission-details`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${data.token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}


export const getPatientById=async(data)=>{
  try {
  
    const response = await api.get(`${Alluser.getPatientById}${data.id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${data.token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}


export const getAudioMetres=async(token)=>{
  try {
  
    const response = await api.get(Alluser.getAudioMeter, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}


export const updatePatientById=async(data)=>{
  try {
  console.log(data.token);
  
    const response = await api.put(`${Alluser.updatePatient}${data.id}`,data.body, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${data.token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}


export const getAllAudiometers=async(data)=>{
  try {
 
  
    const response = await api.get(product.allAudiometers, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${data}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}

export const getAllBookedTests=async(data)=>{
  try {
 
  
    const response = await api.get(service.allBookedTests, {
      headers: {
       'Accept': 'application/json',
        'Authorization': `Bearer ${data}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}

export const getAllRefferelsOnTestById=async(token,id)=>{
  try {
 
  console.log(token,id);
  
    const response = await api.get(service.getAllRefferedPersons+id, {
      headers: {
       'Accept': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}
export const assignRefferelsOnTestConfirm=async(token,data)=>{
  try {
 

  
    const response = await api.post(service.confirmReferralOnTest,data, {
      headers: {
       'Accept': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}

export const assignRefferelsOnTestById=async(token,data)=>{
  try {
 
  console.log(token,id);
  
    const response = await api.post(service.confirmReferralOnTest, {
      headers: {
       'Accept': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}

export const getAllAudiometerById=async(data,id)=>{
  try {
 
  
    const response = await api.get(`${product.audiometerById}${id}`, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${data}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}

export const createAudiometers=async(data,token)=>{
  try {
  
  
    const response = await api.post(product.createAudiometer,data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}

export const getAllProductReferrals=async(token)=>{
  try {
 
  
    const response = await api.get(product.getAllProductReferrals, {
      headers: {
       'Accept': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}

export const getAllServiceReferrals=async(token)=>{
  try {
 
  
    const response = await api.get(service.getAllProductReferrals, {
      headers: {
       'Accept': 'application/json',
        'Authorization': `Bearer ${token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}


export const getAllAvailableDates=async(data)=>{
  try {
 
  
    const response = await api.get(availabilityDate.getAvailability, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${data}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}
export const setNewAvailableDates=async(data,token)=>{
  try {
 
  
    const response = await api.post(availabilityDate.setNewAvailability,data, {
      headers: {
        
        'Authorization': `Bearer ${token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}

export const testBookMaking=async(data,id,token)=>{
  try {
 
  console.log(token);
  
    const response = await api.put(`${test.bookTest}${id}`,data, {
      headers: {
        
        'Authorization': `Bearer ${token}`}
    })
    return response;
    
  } catch (error) {
    throw error; 
  }
}

